module.exports = __webpack_public_path__ + "img/cloud_alert.4f62a624.svg";